<template>
    <div class="product__list">
        <div class="product" v-for="item in products" :style="getProductStyle()">
            <div class="top">
                <div class="follow">
                    <input class="btn__checkbox" type="checkbox" :disabled="user.id == null" :id="item.id" :checked="item.in_wishlist === 1" @change="updateWish($event,item.id)"/>
                    <label class="btn-love" :for="item.id">
                        <svg width="17.916626" height="15.586182" viewBox="0 0 17.9166 15.5862" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <defs/>
                            <path id="Vector" d="M0.62 5.2C0.62 9.79 6.04 13.95 8.95 14.92C11.87 13.95 17.29 9.79 17.29 5.2C17.29 2.67 15.23 0.62 12.7 0.62C11.15 0.62 9.78 1.39 8.95 2.57C8.12 1.39 6.75 0.62 5.2 0.62C2.67 0.62 0.62 2.67 0.62 5.2Z" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.250000"/>
                        </svg>

                    </label>
                </div>
                <div class="params">
                    <div class="item" v-if="item.categories[0]">{{ item.categories[0] }}</div>
                    <div class="item">{{ item.year }}</div>
                </div>
                <SliderImage :images="item.images"></SliderImage>
                <div class="title">{{ item.name }}</div>
                <div class="model__wrapper">
                    <div class="model">{{item.model}}</div>
                    <div class="rewievs" v-if="false">
                            <svg v-for="item in isHalfStar(item.average_rating)" width="16.000000" height="16.000000" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <defs>
                                <clipPath id="clip187_7361">
                                    <rect id="icon" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                                </clipPath>
                            </defs>
                            <rect id="icon" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                            <g clip-path="url(#clip187_7361)">
                                <path id="Union" d="M8 11.51L12.11 14L11.02 9.31L14.66 6.16L9.87 5.75L8 1.33L6.12 5.75L1.33 6.16L4.97 9.31L3.87 14L8 11.51Z" fill="#FFB710" fill-opacity="1.000000" fill-rule="nonzero"/>
                            </g>
                        </svg>

                        <svg v-for="item in 5-isHalfStar(item.average_rating)" width="16.000000" height="16.000000" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <defs>
                                <clipPath id="clip187_7359">
                                    <rect id="icon" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                                </clipPath>
                            </defs>
                            <rect id="icon" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                            <g clip-path="url(#clip187_7359)">
                                <path id="Union" d="M8 4.75L8.64 6.28L8.95 7.02L9.76 7.08L11.4 7.22L10.15 8.31L9.54 8.84L9.72 9.62L10.09 11.23L8.68 10.38L8 9.95L7.31 10.36L5.89 11.22L6.27 9.61L6.45 8.82L5.84 8.3L4.59 7.21L6.23 7.07L7.04 7L7.35 6.26L8 4.75ZM8 1.33L6.12 5.75L1.33 6.16L4.97 9.31L3.87 14L8 11.51L12.11 14L11.02 9.31L14.66 6.16L9.87 5.75L8 1.33Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="nonzero"/>
                            </g>
                        </svg>

                        <div class="number">{{item.average_rating}}</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <a href="">
                    Learn More
                    <svg width="20.000000" height="20.000000" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <clipPath id="clip16_2341">
                                <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                            </clipPath>
                        </defs>
                        <rect id="Icons" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                        <g clip-path="url(#clip16_2341)">
                            <path id="Union" d="M15.99 9.37L12.05 5.44L12.94 4.55L17.94 9.55L18.38 9.99L17.94 10.44L12.94 15.44L12.05 14.55L15.99 10.62L2.5 10.62L2.5 9.37L15.99 9.37Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
                        </g>
                    </svg>

                </a>
            </div>
            <router-link :to="{
                name: 'product',
                params: {
                slug: item.slug
                },
            }">
            </router-link>
        </div>
    </div>
</template>

<script>
import SliderImage from './SliderImage.vue';
import axios from "axios";
export default {
    components: {
        SliderImage,
    },
    props: {
        products: {
        type: Array,
        required: true,
        },
        itemsPerRow: {
        type: Number,
        default: 4, // По умолчанию 3 товара в ряд
        },
        gap: {
        type: Number,
        default: 32, // Расстояние между элементами
        },
    },
    methods: {
        async updateWish(event, id) {
            const data = { event, id };
            this.updateWishlist(data);
        },
        async updateWishlist(event) {
            try {
                let fData = new FormData();
                fData.append("isChecked", event.event.target.checked);
                fData.append("event_id", event.id);
                const response = await axios.post('/post/checked-wishlist', fData);
                this.$emit('updateWish');
            } catch (error) {
                console.error('Error updating wishlist:', error);
            }
        },
        getProductStyle() {
            const totalGaps = (this.itemsPerRow - 1) * this.gap;
            const totalGapWidth = totalGaps/this.itemsPerRow; 
            const widthPercentage = (100/this.itemsPerRow); 
            return {
                width: `calc(${widthPercentage}% - ${totalGapWidth}px)`,
            };
        },
        isHalfStar(e){
            return Math.floor(e);
        },
    },
    computed: {
      user() {
          return this.$store.state.user;
      },
  }
}
</script>

<style scoped>
.product > a{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
}
.bottom{
    background: rgb(255, 255, 255);
    height: 56px;
}
.bottom a{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 100%;

    /* Header/H4: 16px Medium */
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
.model__wrapper{
    display: flex;
    justify-content: space-between;
    gap: 10px;
}
.model__wrapper .model{
     /* Tabs/T1: 13px Medium */
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    height: 26px;
    border-radius: 81px;
    background: rgb(255, 255, 255);
    padding: 0 8px;
    text-wrap: nowrap;
}
.model__wrapper .rewievs{
    display: flex;
    align-items: center;
}
.model__wrapper .rewievs .number{
    color: rgb(5, 5, 5);
    font-family: Satoshi;
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    margin-left: 8px;
}
.btn__checkbox {
  display: none;
}
.btn-love svg path {
  transition: fill 0.5s ease;
}
.btn__checkbox:checked + .btn-love svg path {
  fill: black;
}
.follow {
    position: absolute;
    top: 19px;
    right: 16px;
    border-radius: 100px;
    background: rgb(255, 255, 255);
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 3;
}
.btn-love {
  max-height: 15.88px;
}
.params{
    display: flex;
    gap: 8px;
    padding-bottom: 14px;
}
.params .item{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    padding: 0 8px;
    border-radius: 81px;
    color: rgb(85, 98, 114);
    font-family: Satoshi;
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    background: rgb(255, 255, 255);
}
.product__list{
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
}
.top{
    padding: 19px 16px 12px 16px;
}
.product__list .product{
    width: calc((100%/3) - 21.33px);
    background: rgb(222, 230, 234);

    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.product img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-height: 225px;
}
.product .title{
color: rgb(5, 5, 5);
font-size: 24px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 16px;
padding-TOP: 16px;
}

@media (max-width: 1320px) {
    .model__wrapper{
        flex-direction: column;
    }
    .product__list .product{
        width: calc((100% / 2) - 16px) !important;
    }
}
@media (max-width: 1024px) {
    .product__list .product{
        width: calc((100% / 2) - 16px) !important;
}
}
@media (max-width: 768px) {
    .product__list .product{
        width: 100% !important;
    }
}
</style>